module.exports = {
      id: "subscribe-vikatan-usage",
      viewBox: "0 0 365.232 27",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#subscribe-vikatan",
      toString: function () {
        return this.url;
      }
    }